"use strict";

var PropTypes = require("prop-types");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

class AccountAddressTypeSelector extends React.Component {
	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				thisArg={this}
				config={this.props.addressTypeConfig}
				wizard={AccountStore.get("wizardDefaultAddressTypes")}
				wizardValuesKey="allowedAddressTypes"
				configKey="availableAddressTypes"
				reactComponentName="AccountAddressTypeSelector"
				selectClassName="account-address-type-selector"
				optionsClassName="availableAddressType"
				selectNameAttribute="address.type"
			/>
		);
	}
}

AccountAddressTypeSelector.propTypes = {
	isDesignMode: PropTypes.bool,
	addressTypeConfig: PropTypes.object,
	required: PropTypes.bool,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	reactComponentCategory: PropTypes.string
};

module.exports = AccountAddressTypeSelector;
